import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import LinearProgress from '@mui/material/LinearProgress'
import Sidebar from './Sidebar'
import { drawerWidth } from 'store/constant'
import { useLoading } from 'hooks/useLoading'
import ProgressUpload from 'components/ProgressUpload'
import ProgressDownload from 'components/ProgressDownload'

/** Thanh progress mảnh trên cùng khi có request đang chạy. */
const TopLoader = () => {
  const { isLoading } = useLoading()

  if (!isLoading()) return null
  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, zIndex: 1301, width: '100%' }}>
      <LinearProgress color="primary" sx={{ height: '2px' }} />
    </Box>
  )
}

/** Layout chính sau khi đăng nhập: Sidebar bên trái + nội dung trang (Outlet). */
const MainLayout = () => (
  <Box sx={{ display: 'flex' }}>
    <CssBaseline />
    <TopLoader />
    <Sidebar />

    <Box
      component="main"
      sx={(theme) => ({
        ...theme.typography.mainContent,
        minHeight: '100vh',
        marginTop: 0,
        width: `calc(100% - ${drawerWidth}px)`,
        padding: 'var(--space-16, 16px) var(--space-16, 16px) var(--space-16, 16px) var(--space-12, 12px)',
        [theme.breakpoints.down('md')]: { marginLeft: '20px' },
        [theme.breakpoints.down('sm')]: { marginLeft: '10px', marginRight: '10px' }
      })}
    >
      <Outlet />
    </Box>

    <ProgressUpload />
    <ProgressDownload />
  </Box>
)

export default MainLayout
